import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from "@sentry/angular";

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService implements ErrorHandler {
  handleError(error: any): void {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;

     if (chunkFailedMessage.test(error.message)) {
       window.location.reload();
     } else {
       Sentry.captureException(error);
     }
     
     console.error(error);
   }
}
